import React from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
} from "mdb-react-ui-kit";

import "./Faq.css";

export default function Faq() {
  return (
    <MDBContainer className="mt-4">
      <section>
        <h3 className="text-center mb-2 pb-2 text-primary fw-bold">FAQ</h3>
        <p
          className="text-center mb-4
        "
        >
          Find the answers to the most frequently asked questions below.
        </p>

        <MDBRow>


          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  Does immobilizer need to be on?
                </h6>
                <p>
                  <strong>
                    <u>Yes, atleast in EEPROM, </u>
                  </strong>{" "}
                  Refer to this link {""}
                 <strong> <a href="http://www.ecuconnections.com/forum/viewtopic.php?f=92&t=24769" rel="noreferrer" target="_blank">
                     ecuconnections
                  </a>{" "}
                  </strong>
                  to turn immo off in flash but keep on in EEPROM.VIN must be
                  visible in VCDS engine page.
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>



          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3 ">
              {" "}
                  Which codeblock to choose, I have 3 in my files already?
                </h6>
                <p>
                  Choose whichever came as default in your car. Refer to VCDS
                  soft coding in engine page to get default codeblock.
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>


          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  My car doesn't use CAN cluster, Will it work?
                </h6>
                <p>
                  <strong>No,</strong>
                  You must have CAN based instrument cluster to show map on rpm
                  gauge.
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  My file is 1MB with 8 codeblocks, Will it work?
                </h6>
                <p>
                  <strong>NO,  </strong>
                  Only 512KB is supported as of now.
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  My file has only 1 or 2 codeblocks, How many will be there
                  after patch?
                </h6>
                <p>All Files have 3 Switchable maps after patching.</p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>


          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3 ">
                  Can I tune after making patch with your site?
                </h6>
                <p>
                  <strong>Yes, </strong>
                  You can tune as you like.
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          
          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  What can use to flash?
                </h6>
                <p>MPPS and KESS are tested.Use winols checksums only!</p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

        </MDBRow>
      </section>
    </MDBContainer>
  );
}
